// extracted by mini-css-extract-plugin
module.exports = {"container":"SecurityCountryFooter_container__2MV5b","text":"SecurityCountryFooter_text__3s-ZM","countryLink":"SecurityCountryFooter_countryLink__34AyJ"};